import React from 'react'
import icon1 from "../../assets/Icons1/Signup.png";
import icon2 from "../../assets/Icons1/Book.png";
import icon3 from "../../assets/Icons1/Pickup.png";
import icon4 from "../../assets/Icons1/Transit.png";
import icon5 from "../../assets/Icons1/Delivery.png";

const HowContent = ({children}) => (
    <div>
        <h2 className="section-title text-center m-t-30">How it Works</h2>
        <div className="step flex-between">
            <div className="step-item">
                <div className="step-circle">
                    <img src={icon1} alt='Sign up' />
                </div>
                <h4>Sign Up</h4>
            </div>
            <div className="step-item">
                <div className="step-circle">
                    <img src={icon2} alt='' />
                </div>
                <h4>Book</h4>
            </div>

            <div className="step-item">
                <div className="step-circle">
                    <img src={icon3}  alt='' />
                </div>
                <h4>Pick-up</h4>
            </div>
            <div className="step-item">
                <div className="step-circle">
                    <img src={icon4}  alt='' />
                </div>
                <h4>Transit</h4>
            </div>
            <div className="step-item">
                <div className="step-circle">
                    <img src={icon5}  alt='' />
                </div>
                <h4>Delivery</h4>
            </div>
            <div className="step-line">
                <div></div>
            </div>
        </div>
        <div className="step-content">
        If you want to send a parcel to a customer, relative, friend or client, you are no longer just
restricted to using your local post office.  Wherever it is that you need to send something to,
you can easily find a company that can get it there on time. Ouja, the emerging pick up &amp;
drop service professional company in Chennai, is ideal for shipping documents or small
parcels, commonly on the back of a motorbike, which enables them to be delivered faster
than a van would do.
        </div>
        {children}
    </div>
)

export default HowContent
